<mtg-hockey-game-timeline
  *ngIf="league.sport.isHockey()"
  [game]="game"
  [gameLogs]="logs$ | async"
  [gameUsers]="gameUsers$ | async"
  [sort]="sort"
></mtg-hockey-game-timeline>
<mtg-basketball-game-timeline
  *ngIf="league.sport.isBasketball()"
  [game]="game"
  [gameLogs]="logs$ | async"
  [gameUsers]="gameUsers$ | async"
  [sort]="sort"
></mtg-basketball-game-timeline>
<mtg-volleyball-game-timeline
  *ngIf="league.sport.isVolleyball()"
  [game]="game"
  [gameLogs]="logs$ | async"
  [gameUsers]="gameUsers$ | async"
  [sort]="sort"
></mtg-volleyball-game-timeline>
<mtg-football-game-timeline
  *ngIf="league.sport.isFootball()"
  [game]="game"
  [gameLogs]="logs$ | async"
  [gameUsers]="gameUsers$ | async"
  [sort]="sort"
></mtg-football-game-timeline>
<mtg-handball-game-timeline
  *ngIf="league.sport.isHandball()"
  [game]="game"
  [gameLogs]="logs$ | async"
  [gameUsers]="gameUsers$ | async"
  [sort]="sort"
></mtg-handball-game-timeline>
<mtg-rugby-game-timeline
  *ngIf="league.sport.isRugby()"
  [game]="game"
  [gameLogs]="logs$ | async"
  [gameUsers]="gameUsers$ | async"
  [sort]="sort"
></mtg-rugby-game-timeline>
